import { useHistory } from 'react-router';

export const useGoBack = () => {
    const history = useHistory();
    return (fallbackRoute: string) => {
        if (history.length > 1) {
            history.goBack();
        } else {
            history.replace(fallbackRoute);
        }
    };
};
